import React, { Component } from 'react'

import { makeStyles } from '@material-ui/core/styles'

import { connect } from 'react-redux'
import { postEnrollmentsData, getSISStatus } from '../../actions/'
import Typography from '@material-ui/core/Typography'
import LinearProgress from '@material-ui/core/LinearProgress'
import Button from '@material-ui/core/Button'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'

import GetAppIcon from '@material-ui/icons/GetApp'

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200
  }
}))

function createData(name, downloadLink) {
  return { name, downloadLink }
}

const rows = [
  createData('Users Csv', 'users-template.csv'),
  createData('Enrollment Csv ', 'enrollments.csv'),
  // createData('Group Csv ', 'groups.csv'),
  createData('Delete User Csv ', 'delete-users.csv')
]

function StepOne() {
  const classes = useStyles()

  const downloadPath = process.env.REACT_APP_APP_URL

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label='simple table'>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell align='right'>Download</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.name}>
              <TableCell component='th' scope='row'>
                {row.name}
              </TableCell>
              <TableCell align='right'>
                <Button
                  variant='contained'
                  color='default'
                  href={downloadPath + 'csv-templates/' + row.downloadLink}
                >
                  <GetAppIcon />
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

function mapStateToProps(state) {
  return {
    data: state.rootReducer
  }
}

export default connect(mapStateToProps, {})(StepOne)
